import * as React from 'react';
/**
 *
 * Original name: flashlight off
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=44410%3A32
 *
 */
export const FlashlightOffLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "m14.932 11.77-1.5 1.5h.629v4.82a2 2 0 0 1-2 2h-2a2 2 0 0 1-1.94-1.509L6.97 19.733a3.5 3.5 0 0 0 3.09 1.857h2a3.5 3.5 0 0 0 3.5-3.5v-6.32h-.628Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m5 19.581-1-1 2.56-2.56v-4.25h4.25l1.5-1.5H6.558L5.061 7.02v-1.5h12l1.788-1.789 1 1L5 19.582Zm10.409-12.56-.131.283L13.81 8.77H7.518l-.806-1.75h8.697ZM8.06 13.27h1.25l-1.25 1.25v-1.25Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M17.06 2.5V4h-12V2.5h12Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
